<template>
    <!-- 遮罩层 -->
    <div
        v-if="showModal"
        class="refund-modal-mask"
        @click.self="handleCancel"
        :class="
            showSize === 'big'
                ? 'refund-modal-mask-big'
                : showSize === 'small'
                ? 'refund-modal-mask-small'
                : ''
        "
    >
        <!-- 弹出框主体 -->
        <div class="refund-modal" @click.stop="">
            <!-- 标题 -->
            <div v-if="title" class="refund-modal-header">
                <h3>{{ title }}</h3>
            </div>
            <!-- 内容区域 - 可自定义 -->
            <div class="refund-modal-content">
                <!-- 默认提示信息 -->
                <div v-if="showDefaultTips" class="refund-tips">
                    <p class="tips-text">{{ tipsText }}</p>
                </div>

                <!-- 自定义内容插槽 -->
                <slot name="content">
                    <!-- 默认内容 -->
                    <div
                        v-if="showDefaultContent"
                        class="refund-default-content"
                    >
                        <div class="special-case-section">
                            <label v-if="specialCaseLabel" class="case-label">
                                {{ specialCaseLabel }}
                            </label>
                            <textarea
                                v-model="caseDetails"
                                :placeholder="textareaPlaceholder"
                                class="case-textarea"
                                rows="4"
                            />
                        </div>
                    </div>
                </slot>
            </div>

            <!-- 底部按钮区域 -->
            <div class="refund-modal-footer">
                <!-- 自定义按钮插槽 -->
                <slot name="footer">
                    <!-- 默认按钮 -->
                    <button
                        v-if="showCancel"
                        class="btn-cancel"
                        @click.stop="handleCancel"
                        :style="{ width: cancelBtnWidth }"
                    >
                        {{ cancelLabel }}
                    </button>
                    <button
                        v-if="showSubmit"
                        class="btn-confirm"
                        @click.stop="handleConfirm"
                        :style="{ width: confirmBtnWidth }"
                    >
                        {{ confirmLabel }}
                    </button>
                </slot>
            </div>
            <!-- 删除x icon -->
              <!-- v-if="showDeleteIcon" -->
            <div
                class="delete-icon el-icon-close" v-if="showDeleteIcon"
                @click="handleCancel"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Modal",
    props: {
        // 控制显示隐藏
        showModal: {
            type: Boolean,
            default: false,
        },
        // 标题
        title: {
            type: String,
            default: "",
        },
        // 提示文本
        tipsText: {
            type: String,
            default: "提示信息",
        },
        // 是否显示默认提示
        showDefaultTips: {
            type: Boolean,
            default: true,
        },
        // 是否显示默认内容区域
        showDefaultContent: {
            type: Boolean,
            default: true,
        },
        // 特殊情况标签
        specialCaseLabel: {
            type: String,
            default: "",
        },
        // 文本域占位符
        textareaPlaceholder: {
            type: String,
            default: "",
        },
        // 取消按钮文本
        cancelText: { type: String, default: '' },
        confirmText: { type: String, default: '' },
        // 取消按钮宽度
        cancelBtnWidth: {
            type: String,
            default: "110px",
        },
        // 确定按钮宽度
        confirmBtnWidth: {
            type: String,
            default: "110px",
        },
        // 初始文本内容
        initialCaseDetails: {
            type: String,
            default: "",
        },
        showCancel: {
            type: Boolean,
            default: true,
        },
        showSubmit: {
            type: Boolean,
            default: true,
        },
        showSize: {
            type: String,
            default: "",
        },
        showDeleteIcon: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            caseDetails: this.initialCaseDetails,
            currentLocale: "zh-CN",
        };
    },
    watch: {
        initialCaseDetails(newVal) {
            this.caseDetails = newVal;
        },
        showModal(newVal) {
            this.showModal = newVal;
            if (newVal) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "unset";
            }
        },
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
            },
        },
    },
     computed: {
        cancelLabel() {
            return this.cancelText || this.$t('modal.cancel');
        },
        confirmLabel() {
            return this.confirmText || this.$t('modal.confirm');
        },
    },
    methods: {
        // 取消事件
        handleCancel() {
            this.$emit("cancel");
            this.$emit("update:visible", false);
        },

        // 确认事件
        handleConfirm() {
            const result = {
                caseDetails: this.caseDetails,
            };
            this.$emit("confirm", result);
            this.$emit("update:visible", false);
        },
    },
};
</script>

<style lang="stylus" scoped>
// 遮罩层
.refund-modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease;

    .refund-modal {
        width: 640px;
        // height: 460px;
        background-color: #fff;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        overflow: hidden;
        animation: slideIn 0.3s ease;
        // background: linear-gradient(0deg, #F0F7FF 0%, #FAFCFF 22%, #FAFCFF 100%);
        background-color: #fff;
        border-radius: 20px;
        position: relative;

        .refund-modal-header {
            padding: 20px 24px 16px;

            // border-bottom: 1px solid #f0f0f0;
            h3 {
                margin: 0;
                font-weight: 600;
                text-align: center;
                font-weight: 800;
                font-size: 26px;
                color: #011E41;
                line-height: 33px;
            }
        }

        // 内容区域
        .refund-modal-content {
            padding: 24px;
        }
    }
}

// 提示信息
.refund-tips {
    margin-bottom: 20px;
    padding: 12px 16px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #1890ff;

    .tips-text {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
        color: #666;
    }
}

.el-icon-close {
    font-size: 36px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 5;
    color: #000;
}

// 小弹框
.refund-modal-mask-small {
    >.refund-modal {
        width: 398px;
        height: 398px;
    }

    .refund-modal-content {
        padding: 10px;
        // height: 100%;
        // overflow: scroll;
    }

    .btn-confirm {
        width: 150px !important;
        height: 44px;
    }

    .el-result {
        padding: 20px;
    }
}

// 大弹框 考位样式
.refund-modal-mask-big {
    >.refund-modal {
        width: 58%;
        // height: 62%;
        height: calc(100vh - 220px);

        // overflow: scroll;
        .refund-modal-content {
            // overflow: scroll;
        }
    }
}

// 特殊情况区域
.special-case-section {
    margin-top: 16px;

    .case-label {
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }

    .case-textarea {
        width: 100%;
        padding: 12px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        font-size: 14px;
        line-height: 1.5;
        color: #333;
        resize: vertical;
        box-sizing: border-box;
        transition: all 0.3s;

        &:focus {
            outline: none;
            border-color: #1890ff;
            box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
        }

        &::placeholder {
            color: #bfbfbf;
        }
    }
}

// 底部按钮区域
.refund-modal-footer {
    padding: 12px 24px;
    // border-top: 1px solid #f0f0f0;
    display: flex;
    justify-content: center;
    gap: 12px;

    button {
        width: 180px !important;
        height: 50px;
        border-radius: 25px;
        border: 1px solid #0043E0;
        font-size: 18px;
        cursor: pointer;
        // &:focus {
        // outline: none;
        // }
    }

    .btn-cancel {
        background-color: #fff;
        color: #0043E0;
        cursor: pointer;
    }

    .btn-confirm {
        background-color: #0043E0;
        color: #fff;
        cursor: pointer;
    }
}

// 动画效果
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 640px) {
    .refund-modal-mask {
        .refund-modal {
            width: 90vw;
            min-height: 50vh;

            .refund-modal-header {
                padding: 4vw;

                h3 {
                    font-size: 6vw;
                }
            }

            .refund-modal-content {
                padding: 4vw;
            }

            .refund-modal-footer {
                // padding: 3vw;
                justify-content: center;

                button {
                    width: 32vw !important;
                    height: 10vw;
                    border-radius: 25px;
                    font-size: 4vw;
                    // &:focus {
                    // outline: none;
                    // }
                }
            }
        }
    }

    .refund-modal-mask-small {
        >.refund-modal {
            width: 78vw;
            // height: 40vh;
            min-height: 40vh;
            }

            .refund-modal-content {
            padding: 5vw 4vw;
        }
            
        .btn-confirm {
            width: 20vw !important;
            height: 4vw;
        }

        .el-result {
            padding: 2vw;
        }
    }

    .refund-modal-mask-big {
        >.refund-modal {
            width: 95vw;
            height: 80vh;
        }
    }
    .el-icon-close { 
        font-size: 6.8vw;
    }
}
</style>